<template>
	<div class="kyc w100">
		<div class="select_area mb_10">
			<select
				class="contact_type"
				v-model="typeSeq"
				@change="loadKycCertificationForm"
			>
				<option
					v-for="item in certificationTypes"
					:key="item.seq"
					:value="item.seq"
				>
					{{ item.title }}
				</option>
			</select>
			<span class="select_icon"></span>
		</div>
		<div v-if="!kycCertification">
			<div v-for="form in kycForm" :key="form.seq" class="kyc_input_area">
				<h3 class="form_title">{{ form.title }}</h3>
				<p class="mb_10">{{ form.description }}</p>
				<div
					v-for="(field, idx) in form.fields"
					:key="field.seq"
					class="field_area"
				>
					<h4 class="field_title">{{ field.title }}</h4>
					<p class="mb_10">{{ field.description }}</p>
					<template v-if="field.field_type === 'INPUT'">
						<input
							type="text"
							v-model="form.fieldValues[idx].value"
							class=""
							:placeholder="field.placeholder"
						/>
					</template>
					<template v-if="field.field_type === 'TEXTAREA'">
						<textarea rows="5" v-model="form.fieldValues[idx].value"></textarea>
					</template>
					<template v-if="field.field_type === 'RADIO'">
						<div v-for="item in field.options" :key="item.seq" class="mb_10">
							<input
								type="radio"
								:name="'radio_' + form.seq + '_' + idx"
								v-model="form.fieldValues[idx].optionSeq"
								:value="item.seq"
							/>
							<label>{{ item.title }}</label>
						</div>
					</template>
					<template v-if="field.field_type === 'SELECT'">
						<div class="select_area">
							<select v-model="form.fieldValues[idx].optionSeq">
								<option
									v-for="item in field.options"
									:key="item.seq"
									:value="item.seq"
								>
									{{ item.title }}
								</option>
							</select>
							<span class="select_icon"></span>
						</div>
					</template>
					<template v-if="field.field_type === 'CHECKBOX'">
						<div v-for="item in field.options" :key="item.seq">
							<input
								type="checkbox"
								:name="'checkbox' + form.seq + '_' + idx"
								v-model="form.fieldValues[idx].options"
								:value="item.seq"
							/>
							<label for="">{{ item.title }}</label>
						</div>
					</template>
					<template v-if="field.field_type === 'MULTISELECT'">
						<p>멀티셀렉</p>
						<div class="select_area">
							<select v-model="form.fieldValues[idx].options" multiple size="1">
								<option
									v-for="item in field.options"
									:key="item.seq"
									:value="item.seq"
								>
									{{ item.title }}
								</option>
							</select>
							<span class="select_icon"></span>
						</div>
					</template>
					<template v-if="field.field_type === 'FILE'">
						<p>파일</p>
						<input type="file" name="" id="" />
					</template>
				</div>
			</div>
			<div v-if="kycForm.length > 0" class="kyc_button_area tar">
				<button @click="createCertification">인증</button>
			</div>
		</div>
		<div v-else>
			{{
				kycCertification.status === 'REJECTED'
					? 'kyc인증이 거절되었습니다.'
					: kycCertification.status === 'PENDING'
					? 'kyc인증 심사중 입니다.'
					: '인증이 완료된 항목입니다.'
			}}
		</div>
	</div>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div class="status_icon success"></div>
		<p class="status_text">kyc인증이 완료되었습니다.</p>
		<div class="button_area">
			<button class="fc_red oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import {
	createCertification,
	fetchCertificationList,
	fetchCertificationTypes,
} from '@/api/kyc';
import { commonError } from '@/common/dialog';
import { fetchKycCertificationTypeForm } from '@/api/form';
import ModalMessage from '@/components/Layout/ModalMessage';
export default {
	name: 'Kyc',
	components: { ModalMessage },
	data() {
		return {
			kycCertificationList: [],
			typeSeq: '',
			certificationTypes: [],
			kycForm: [],
			messageModal: false,
		};
	},
	computed: {
		kycCertification() {
			return this.kycCertificationList.find(item => {
				return item.type_seq === this.typeSeq;
			});
		},
	},
	created() {
		Promise.all([
			this.loadKycCertificationType(),
			this.loadKycCertification(),
		]).catch(commonError);
	},
	methods: {
		async loadKycCertification() {
			const { data } = await fetchCertificationList({}).catch(commonError);
			this.kycCertificationList = data;
		},
		async loadKycCertificationType() {
			const { data } = await fetchCertificationTypes().catch(commonError);
			this.certificationTypes = data;
		},
		async loadKycCertificationForm() {
			const params = {
				type_seq: this.typeSeq,
				target_type: 'KYC_CERTIFICATION',
			};
			const { forms } = await fetchKycCertificationTypeForm(params).catch(
				commonError,
			);
			this.kycForm = forms.map(form => {
				let result;
				const fieldValues = form.fields.map(field => {
					return {
						fieldSeq: field.seq,
						value: '',
						optionSeq: null,
						options: [],
					};
				});
				result = { ...form, fieldValues: fieldValues };
				return result;
			});
		},
		async createCertification() {
			const fieldValues = [];
			this.kycForm.forEach(form => {
				form.fieldValues.forEach(field => {
					fieldValues.push({
						field_seq: field.fieldSeq,
						option_seq: field.optionSeq,
						value: field.value,
						options: field.options.map(option => {
							return { option_seq: option };
						}),
					});
				});
			});
			const data = {
				type_seq: this.typeSeq,
				field_values: fieldValues,
			};

			createCertification(data)
				.then(() => {
					this.messageModal = true;
				})
				.catch(commonError);
		},
	},
};
</script>
